import { render, staticRenderFns } from "./CartSend.vue?vue&type=template&id=54abf853&"
import script from "./CartSend.vue?vue&type=script&lang=js&"
export * from "./CartSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports